/* gorilla-gallery.js — Product image gallery with scroll-snap + thumbnail sync */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var track      = document.getElementById('gorilla-gallery-track');
    var thumbStrip = document.getElementById('gorilla-thumbs-strip');
    var thumbs     = document.querySelectorAll('[data-gallery-thumb]');
    var prevBtn    = document.getElementById('gorilla-gallery-prev');
    var nextBtn    = document.getElementById('gorilla-gallery-next');
    var thumbPrev  = document.getElementById('gorilla-thumbs-prev');
    var thumbNext  = document.getElementById('gorilla-thumbs-next');
    if (!track) return;

    var slides  = Array.from(track.querySelectorAll('[data-gallery-slide]'));
    var current = 0;

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      current = index;
      slides[current].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      syncThumbs();
    }

    function syncThumbs() {
      thumbs.forEach(function (thumb, i) {
        var active = i === current;
        thumb.classList.toggle('gorilla-gallery__thumb--active', active);
        thumb.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      if (!thumbStrip || !thumbs[current]) return;
      var thumb      = thumbs[current];
      var stripRect  = thumbStrip.getBoundingClientRect();
      var thumbRect  = thumb.getBoundingClientRect();

      /* Convert viewport positions to scroll-space coordinates */
      var thumbScrollLeft  = thumbRect.left  - stripRect.left + thumbStrip.scrollLeft;
      var thumbScrollRight = thumbRect.right - stripRect.left + thumbStrip.scrollLeft;
      var visLeft   = thumbStrip.scrollLeft;
      var visRight  = visLeft + thumbStrip.clientWidth;
      var maxScroll = thumbStrip.scrollWidth - thumbStrip.clientWidth;

      /* Fully visible — nothing to do */
      if (thumbScrollLeft >= visLeft && thumbScrollRight <= visRight) return;

      if (thumbScrollRight > visRight) {
        /* Thumb clipped on right — scroll it into view */
        thumbStrip.scrollTo({ left: Math.min(thumbScrollLeft, maxScroll), behavior: 'smooth' });
      } else {
        /* Thumb clipped on left — scroll it into view */
        thumbStrip.scrollTo({ left: thumbScrollLeft, behavior: 'smooth' });
      }
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i); });
    });

    /* Main gallery prev/next */
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    /* Thumbnail strip scroll by 6 thumbs */
    function scrollStrip(direction) {
      if (!thumbStrip || !thumbs.length) return;
      var thumbW = thumbs[0].offsetWidth;
      var gap    = parseInt(getComputedStyle(thumbStrip).gap) || 8;
      var amount = (thumbW + gap) * 6 * direction;
      var target = thumbStrip.scrollLeft + amount;
      thumbStrip.scrollTo({ left: target, behavior: 'smooth' });
    }

    var thumbsWrap = thumbStrip && thumbStrip.closest('.gorilla-pdp-hero__thumbs-wrap');

    function updateStripArrows() {
      if (!thumbStrip) return;
      var atStart = thumbStrip.scrollLeft <= 2;
      var atEnd   = thumbStrip.scrollLeft + thumbStrip.clientWidth >= thumbStrip.scrollWidth - 2;
      if (thumbPrev) thumbPrev.style.display = atStart ? 'none' : 'flex';
      if (thumbNext) thumbNext.style.display = atEnd   ? 'none' : 'flex';
      if (thumbsWrap) {
        thumbsWrap.classList.toggle('has-prev', !atStart);
        thumbsWrap.classList.toggle('has-next', !atEnd);
      }
    }

    if (thumbPrev) thumbPrev.addEventListener('click', function () { scrollStrip(-1); });
    if (thumbNext) thumbNext.addEventListener('click', function () { scrollStrip(1); });
    if (thumbStrip) thumbStrip.addEventListener('scroll', updateStripArrows, { passive: true });
    updateStripArrows();

    /* Mouse drag-to-scroll on desktop */
    var isDragging    = false;
    var dragStartX    = 0;
    var dragScrollLeft = 0;

    function endDrag() {
      if (!isDragging) return;
      isDragging = false;
      track.style.scrollSnapType = '';
      track.style.cursor = '';
      document.body.style.userSelect = '';
      /* Snap to nearest slide after release */
      var slideW = track.offsetWidth;
      var nearest = Math.round(track.scrollLeft / slideW);
      goTo(nearest);
    }

    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    track.addEventListener('mousedown', function (e) {
      e.preventDefault();
      isDragging     = true;
      dragStartX     = e.clientX;
      dragScrollLeft = track.scrollLeft;
      track.style.scrollSnapType = 'none';
      track.style.cursor = 'grabbing';
      document.body.style.userSelect = 'none';
    });

    document.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      var dx = e.clientX - dragStartX;
      track.scrollLeft = dragScrollLeft - dx;
    });

    document.addEventListener('mouseup', endDrag);
    track.addEventListener('mouseleave', endDrag);

    /* Scroll-snap sync: detect which slide is in view */
    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var slideW  = track.offsetWidth;
        var newIdx  = Math.round(track.scrollLeft / slideW);
        if (newIdx !== current) { current = newIdx; syncThumbs(); }
      }, 80);
    }, { passive: true });

    /* variant:change → show first image that matches new variant */
    window.addEventListener('variant:change', function (e) {
      var variantId = e.detail && e.detail.variantId;
      if (!variantId) return;
      slides.forEach(function (slide, i) {
        if (slide.getAttribute('data-variant-id') === String(variantId)) {
          goTo(i);
        }
      });
    });

    syncThumbs();
  });
})();
